'use strict';

bbw.model.CommentCollection = ngtk.model.List.extend({

    _itemModel: bbw.model.Comment,

    _state: undefined,
    _loadArgs: undefined,

    _postId: undefined,
    _revOrder: false,
    _unreadMode: false,
    _perPage: 10,
    _maxPerPage: 20,
    _totalCount: undefined,
    _markRead: false,
    _maxReadTs: undefined,

    _initialize: function() {
        this._items = {};
        this._itemsScopeData = [];
        this._state = {
            wasLoaded: false
        };
    },

    empty: function() {
        this._cleanObject('_items');
        this._cleanObject('_state');
        this._updateItemsScopeData();
        return this;
    },

    configure: function(postId, totalCount, revOrder, perPage, maxPerPage, markRead) {
        this._postId = postId;
        this._totalCount = totalCount;
        this._revOrder = !!revOrder;
        this._perPage = ngtk.tools.math.intval(perPage, 1);
        this._maxPerPage = ngtk.tools.math.intval(maxPerPage, this._perPage || 1);
        this._markRead = !!markRead;
        this._maxReadTs = 0;
    },

    markRead: function(ts) {
        if (!this._markRead || ts < 0) {
            return this.$q.when();
        }
        if (angular.isDefined(ts)) {
            ts = parseInt(ts);
            if (!(ts > 0)) {
                ts = null;
            }
        } else {
            ts = null;
        }
        if (ts && ts <= this._maxReadTs) {
            return this.$q.when();
        }
        if (ts) {
            this._maxReadTs = ts;
        }
        return this._api.post('posts/mark-read', {id: this._postId, timestamp: ts}).execute().then(function(response) {
            var responseTs = parseInt(response.timestamp);
            if (!isNaN(responseTs) && responseTs > this._maxReadTs) {
                this._maxReadTs = responseTs;
            }
        }.bind(this));
    },

    /**
     * @param {boolean} revOrder
     * @returns {boolean} is changed
     */
    setRevOrder: function(revOrder) {
        var newRevOrder = !!revOrder;
        if (newRevOrder != this._revOrder) {
            this._revOrder = newRevOrder;
            this._state.wasLoaded = false;
            return true;
        }
        return false;
    },

    setWasLoaded: function() {
        this._state.wasLoaded = true;
    },

    /**
     * @param {boolean} unreadMode
     * @returns {boolean} is changed
     */
    setUnreadMode: function(unreadMode) {
        var newUnreadMode = !!unreadMode;
        if (newUnreadMode != this._unreadMode) {
            this._unreadMode = newUnreadMode;
            this._state.wasLoaded = false;
            return true;
        }
        return false;
    },

    wasLoaded: function() {
        return this._state.wasLoaded;
    },

    ensureIsLoaded: function() {
        if (this.wasLoaded()) {
            return this.$q.when(this);
        } else {
            return this.load().then(function() {
                return this;
            }.bind(this));
        }
    },

    getUnreadLessCount: function() {
        var availableCount;

        if (this._state.before) {
            availableCount = this._state.before.count;
        }

        if (!availableCount) {
            return 0;
        }

        var maxPerPage;
        if (this._maxPerPage) {
            maxPerPage = this._maxPerPage;
        } else {
            maxPerPage = this._perPage;
        }

        if (availableCount > maxPerPage) {
            return maxPerPage;
        }

        return availableCount;
    },

    getMoreCount: function() {
        var availableMoreCount;

        if (this._state.after) {
            availableMoreCount = this._state.after.count;
        }

        if (angular.isUndefined(availableMoreCount)) {
            availableMoreCount = this._totalCount;
        }

        if (!availableMoreCount) {
            return 0;
        }

        var maxPerPage;
        if (this._maxPerPage) {
            maxPerPage = this._maxPerPage;
        } else {
            maxPerPage = this._perPage;
        }

        if (availableMoreCount > maxPerPage) {
            return maxPerPage;
        }

        return availableMoreCount;
    },

    load: function(more, pages) {
        var limit;
        if (pages > 1) {
            limit = this._perPage * pages;
        }
        return this._load(more, limit);
    },

    loadMore: function() {
        return this._load(1);
    },

    loadLess: function() {
        return this._load(-1);
    },

    incrementCount: function(value) {
        if (angular.isUndefined(value)) {
            value = 1;
        }
        this._state.totalCount = this.getCount() + value;
        return this._state.totalCount;
    },

    getTotalCount: function() {
        return this._state.totalCount;
    },

    getCount: function() {
        return this._state.totalCount || this._totalCount || 0;
    },

    reload: function() {
        return this._load();
    },

    _load: function(more, limit) {
        var cfg = {
            post_id: this._postId,
            direction: this._revOrder ? 'desc' : 'asc'
        };

        if (angular.isUndefined(limit)) {
            limit = (this._maxPerPage || this._perPage);
        }

        if (limit > 0) {
            cfg.limit = limit;
        }

        if (this._unreadMode && more >= 0) {
            cfg.unread = 1;
        }

        var ignoreBefore = false;

        if (more > 0) {
            if (angular.isObject(this._state.after)) {
                angular.extend(cfg, this._state.after.args);
                if (this._unreadMode) {
                    ignoreBefore = true;
                }
            } else {
                more = false;
            }
        } else if (more < 0) {
            if (angular.isObject(this._state.before)) {
                angular.extend(cfg, this._state.before.args);
                if (this._unreadMode) {
                    cfg.direction = !this._revOrder ? 'desc' : 'asc';
                    cfg.reverse = true;
                }
            } else {
                more = false;
            }
        }

        this._state.loading = true;
        if (!more) {
            this._state.initialLoading = true;
        }

        return this._loadFromApi('get', 'comments', cfg).then(function(response) {
            this._updateStateFromResponse(response, ignoreBefore, cfg.reverse);
            this._setFromApiResult(response.comments.items, !!more);
            if (!cfg.reverse && this._markRead) {
                if (angular.isArray(response.comments.items) && response.comments.items.length) {
                    this.markRead(response.comments.items.reduce(function(carry, comment) {
                        return Math.max(comment.created_at, carry);
                    }, -1));
                } else {
                    this.markRead();
                }
            }
            return response.comments.items && response.comments.items.length;
        }.bind(this)).finally(function() {
            delete this._state.initialLoading;
            delete this._state.loading;
        }.bind(this));
    },

    isLoading: function() {
        return !!this._state.loading;
    },

    _updateStateFromResponse: function(response, ignoreBefore, reverse) {
        var updates = {
            wasLoaded: true,
            before: response.comments.before,
            after: response.comments.after,
            totalCount: response.comments.count
        };
        if (reverse) {
            if (this._revOrder) {
                updates.after = updates.before;
                updates.before = this._state.before;
            } else {
                updates.before = updates.after;
                updates.after = this._state.after;
            }
        } else if (ignoreBefore) {
            if (this._revOrder) {
                updates.after = this._state.after;
            } else {
                updates.before = this._state.before;
            }
        }
        ngtk.tools.object.replace(this._state, updates);
        this._state.nextMoreCount = this.getMoreCount();
        if (this._unreadMode) {
            this._state.nextLessCount = this.getUnreadLessCount();
            this._state.nextLoadCount = this._state.nextLessCount;
        } else {
            this._state.nextLoadCount = this._state.nextMoreCount;
        }
    },

    _updateItemsScopeData: function() {
        this._itemsScopeData.length = 0;
        angular.forEach(this._items, function(item) {
            item.wireScope(this._itemsScopeData, item.$$idx);
        }.bind(this));
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        if (angular.isUndefined(scopeInnerPtr[scopeInnerElement])) {
            scopeInnerPtr[scopeInnerElement] = {};
        }
        scopeInnerPtr[scopeInnerElement]['items'] = this._itemsScopeData;
        scopeInnerPtr[scopeInnerElement]['state'] = this._state;
        scopeInnerPtr[scopeInnerElement].$model = this;
    }

});